<template lang="pug">
  .b2b-page-add-accountingclose-draft
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8', v-if='!this.draftId')
            div {{ $t('accounting_closes.new_accounting') }}
          ods-col(:span='8', v-if='this.draftId')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16', v-if='this.draftId')
            ods-row(type='flex', justify='end')
              ods-button(
                type='primary',
                icon='ods-icon-delete',
                size='small',
                circle,
                @click.native='deleteAccountingClose')
                | {{ $t('buttons.btnDelete') }}
      ods-form(
        ref='draftDetailForm',
        :rules='rulesDraftDetailForm',
        :model='draftDetailForm',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              v-if='activeUser.data.isSuperAdmin || !activeUser.data.projects || (activeUser.data.projects && activeUser.data.projects.length > 1)',
              :label='$t("accounting_closes.entity_table.project")',
              prop='projectName')
              ods-select(
                v-model='draftDetailForm.projectName',
                :disabled='(isSavedAccounting || this.draftId!=null)'
                filterable,
                @change='getProject')
                ods-option(
                  v-for='project in optionsService',
                  :key='project.id',
                  :label='project.name',
                  :value='project.id')
            ods-form-item(
              prop='name',
              :label='$t("accounting_closes.entity_table.name")')
              ods-input(
                v-model="draftDetailForm.name")
            ods-form-item(
              :label='$t("accounting_closes.entity_table.date_info")',
              prop='startDate')
                ods-date-picker(
                  v-model='dateTimePickerValueCloseDatePeriod',
                  type='daterange',
                  @change='getDateTimePickerValueCloseDatePeriod',
                  :range-separator='$t("msg_generics.datepicker.separator_empty")',
                  :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                  :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                  :format='$t("date_format_calendar")',
                  prefix-icon='prefix-icon-date-time-picker',
                  :showFooterButtons='true',
                  align='right')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("accounting_closes.entity_table.buyer")',
              prop='buyerName')
              ods-select(
                v-model='draftDetailForm.buyerName',
                :disabled='(isSavedAccounting || this.draftId!=null)'
                filterable,
                :filter-method='filterPartiesBuyer',
                :placeholder='$t("new_invoice.new_invoice_form.select_placeholder")')
                ods-option(
                  v-for='buyer in optionsBuyer',
                  :key='buyer.id',
                  :label="(buyer.taxIdentificationNumber?buyer.taxIdentificationNumber + ' - ':'') + buyer.tradeName",
                  :value='buyer.id')
            ods-form-item(
              prop='description',
              :label='$t("accounting_closes.entity_table.description")')
              ods-input(
                v-model="draftDetailForm.description")
            ods-form-item(
              v-if='(isSavedAccounting || this.draftId) && draftDetailForm.childAccountingCloseName',
              prop='childAccountingCloseName',
              :label='$t("accounting_closes.entity_table.child_accounting_close_name")')
              ods-input.withIcon(
                :disabled='true',
                v-model="draftDetailForm.childAccountingCloseName")
              div.icon
                ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
                  ods-button(
                    v-if='draftDetailForm.childAccountingCloseName',
                    icon='ods-icon-close',
                    size='small',
                    circle,
                    @click.native='cleanChildAccountingClose()')
    //- Tabla facturas asociadas a un cierre contable
    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(v-if='invoices.length', name='2')
          template(slot='title')
            span  {{ $t('accounting_closes_detail.invoices.title') }}
            span.info(v-show='!invoices.length') {{ $t('msg_generics.no_match') }}
          ods-table(
            v-if='invoices.length > 0',
            :data='invoices',
            :default-sort="{prop: 'id', order: 'ascending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='buyerName',
              :label='$t("accounting_closes_detail.invoices.buyer")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='sellerName',
              :label='$t("accounting_closes_detail.invoices.seller")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='invoiceNumber',
              :label='$t("accounting_closes_detail.invoices.invoice_number")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='issueDate',
              :label='$t("accounting_closes_detail.invoices.issue_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='creationDateTime',
              :label='$t("accounting_closes_detail.invoices.creation_date_time")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='totalExecutableAmount',
              :label='$t("accounting_closes_detail.invoices.total_executable_amount")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='currencyCode',
              :label='$t("accounting_closes_detail.invoices.currency")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='status',
              :label='$t("accounting_closes_detail.invoices.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatusInvoice',
              sortable='')
            ods-table-column(
              prop='projectName',
              :label='$t("accounting_closes_detail.invoices.project")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='receptionMethod',
              :label='$t("accounting_closes_detail.invoices.reception_method")',
              :show-overflow-tooltip='true',
              :formatter='formatterCommunicationMethod',
              sortable='')
            ods-table-column(
              width='150'
              align='center',
              :label='$t("order.order_entity_table_detail.options")'
              :show-overflow-tooltip='true'
              sortable='')
              template(slot-scope="scope")
                ods-tooltip(:content='$t("invoice_detail.buttons.download_invoice_tooltip")', placement='bottom')
                  ods-button(
                    type='neutral',
                    @click.native='handleDownloadInvoicePdf(scope.row, scope)')
                    ods-icon(name='download', size='16', circle)
                ods-tooltip(:content='$t("invoices.tooltip.attachments")', placement='bottom')
                  ods-button(
                    type='neutral',
                    v-if="scope.row.withAttachment!==null && scope.row.withAttachment && canSeeAttachments",
                    @click.native='handleShowSeeAttachments(scope.row, scope)')
                    ods-icon(name='clip', size='16', circle)
                ods-tooltip(:content='$t("invoices.tooltip.events")', placement='bottom')
                  ods-button(
                    type='neutral',
                    v-if="canSeeEvents",
                    @click.native='handleShowSeeEvents(scope.row, scope)')
                    ods-icon(name='clock', size='16', circle)
                ods-tooltip(:content='$t("buttons.btnDelete")', placement='left')
                  ods-button(
                    v-if='draftId',
                    type='neutral',
                    align='center',
                    style=' padding-left: 0px; padding-right: 0px; color: #2E6C99;'
                    @click='handleRemoveInvoice(scope.row)')
                    ods-icon(name='close', size='16')
          ods-row.b2b-table-facturas-recibidas__pagination()
            ods-col.b2b-table-facturas-recibidas__pagination--right(:span='20')
              ods-pagination(
                ref='paginationInvoices',
                popper-class='b2b-pagination__dropdown',
                @size-change='pageInvoicesSizeChanged',
                @current-change='currentPageInvoicesChanged',
                :current-page.sync='paginationInvoices.currentPage',
                :page-sizes='[20, 50, 100]',
                :page-size='paginationInvoices.pageSize',
                layout='total, sizes, prev, pager, next, slot',
                :total='paginationInvoices.totalElements')
            ods-col(:span='4')
              ods-button.margintop(
                v-if='invoices.length > 0',
                type='primary',
                size='small',
                @click='handleRemoveAllInvoice()')
                | {{ $t('buttons.btnDeleteAll') }}
              ods-button.margintop(
                v-if='invoices.length > 0',
                type='primary',
                size='small',
                @click='handleCloseAccounting()')
                | {{ $t('accounting_closes.entity_table.close_accounting') }}
    ods-module.collapse
      ods-accordion(v-model='activateLinesInvoice', @change='')
        ods-accordion-item(
          v-if='isShowSeeAttachments',
          name='1')
          template(slot='title')
            span {{ $t('invoice_detail.attachment') }}
            span.info(v-show='!attachments.length') {{ $t('invoice_detail.no_attachment') }}
          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            :default-sort='{ prop: "creationDate", order: "descending" }',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterAttach',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("invoice_detail.attachments_table.filename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("invoice_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              :formatter= 'formatterCategory',
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("invoice_detail.attachments_table.size")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("invoice_detail.attachments_table.compressed_size")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='creationDate',
               width='110',
              :label='$t("invoice_detail.attachments_table.creation_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("invoice_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              width='80',
              align='center',
              :label='$t("order.order_entity_table_detail.options")'
              :show-overflow-tooltip='true')
              template(slot-scope='scope')
                ods-button.first-button(
                  type='neutral',
                  @click='downloadAttachment')
                  ods-icon(name='download', size='16')
    ods-module.collapse
      ods-accordion(v-model='activateLinesInvoice', @change='')
        ods-accordion-item(
          v-if='isShowSeeEvents',
          name='2')
          template(slot='title')
            span {{ $t('invoice_detail.events.title') }}
            span.info(v-show='!events.length') {{ $t('msg_generics.no_match') }}
            i(class='header-icon el-icon-information')
          ods-row()
            b2b-timeline(:events='events')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          v-if='isSavedAccounting || this.draftId',
          type='primary',
          size='large'
          @click='getAccountingClosesList()')
          | {{ $t('accounting_closes.entity_table.add') }}
        ods-button(
          v-if='isSavedAccounting || this.draftId',
          type='primary',
          size='large'
          @click='getInvoiceList()')
          | {{ $t('accounting_closes.add_invoices') }}
        ods-button(
          type='primary',
          size='large'
          @click='saveAccountingData("draftDetailForm")')
          | {{ $t('buttons.btnSave') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTableMenuAccountingCloseDraft from '@/views/cierrescontablesborradores/B2bTableMenuAccountingCloseDraft'
import B2bTimeline from '@/components/B2bTimeline'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-add-accountingclose-draft',
  mixins: [Utils],
  data () {
    return {
      draftId: null,
      cierresContables: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'closeDateTime'
        },
        totalElements: 0,
        totalPages: 0
      },
      tid: null,
      invoices: {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'id'
        },
        totalElements: 0,
        totalPages: 0
      },
      loading: false,
      tableSort: {
        prop: 'closeDateTime',
        order: 'descending'
      },
      tableInvoiceSort: {
        prop: 'id',
        order: 'descending'
      },
      pagination: {
        currentPage: 0,
        totalElements: 0,
        pageSize: 20
      },
      paginationInvoices: {
        currentPage: 0,
        totalElements: 0,
        pageSize: 20
      },
      activateLines: ['1'],
      activateLinesInvoice: ['1'],
      accountingCloses: [],
      optionsService: [],
      optionsBuyer: [],
      auxListPartiesBuyer: [],
      dateTimePickerValueCloseDatePeriod: [],
      invoiceId: null,
      draftDetailForm: {
        projectName: null,
        buyerName: null,
        name: null,
        description: null,
        startDate: null,
        endDate: null,
        childAccountingCloseName: null
      },
      multipleSelection: [],
      multipleSelectionIds: [],
      queryParams: {},
      queryParamsInvoices: {},
      currentRow: {},
      isShowAccountingClosesList: false,
      isShowInvoicesList: false,
      isSavedAccounting: false,
      isShowSaveButton: true,
      isShowSeeAttachments: false,
      isShowSeeEvents: false,
      // ADJUNTOS
      attachments: [],
      currentRowAttachments: {},
      fileList: [],
      // EVENTOS
      events: [],
      searchType: 'RECEIVED'
    }
  },

  components: {
    B2bTimeline,
    B2bTableMenuAccountingCloseDraft,
    B2bTableSelectRows
  },

  computed: {
    ...mapGetters([
      // Permisos
      'activeUser',
      'optionsServicesEnabled',
      'optionsBuyersCreateInvoice',
      'isBuyerFilterable',
      'accountingCloseDraft',
      'queryAccountingCloseDraft',
      'isAccountingCloseTableProjectNameShown',
      'isAccountingCloseTableBuyerNameShown',
      'isAccountingCloseTableNameShown',
      'isAccountingCloseTableCloseDateTimeShown',
      'isAccountingCloseTableStatusShown',
      'isAccountingCloseTableStartDateShown',
      'isAccountingCloseTableEndDateShown',
      'isAccountingCloseTableChildAccountingCloseNameShown',
      'canSeeAttachments',
      'canSeeEvents'

    ]),

    rulesDraftDetailForm () {
      const checkBuyer = (rule, value, callback) => {
        const idProject = this.draftDetailForm.projectName
        if (idProject === null || idProject === '') {
          callback(new Error(this.$t('new_invoice.new_invoice_form.rules_form.select_project_first')))
        } else {
          callback()
        }
      }
      const checkDates = (rule, value, callback) => {
        const a = moment(this.draftDetailForm.endDate)
        const b = moment(this.draftDetailForm.startDate)
        const years = a.diff(b, 'year')
        if (years > 0) {
          callback(new Error(this.$t('msg_generics.date_diff_error')))
        } else {
          callback()
        }
      }
      return {
        startDate: [
          { validator: checkDates, trigger: 'blur, change' },
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        projectName: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        buyerName: [
          { validator: checkBuyer, trigger: 'blur, change' },
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ],
        name: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { max: 50, message: this.$t('validations.maxlenght', { maxlenght: 50 }), trigger: 'change' }
        ],
        description: [
          { max: 250, message: this.$t('validations.maxlenght', { maxlenght: 250 }), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'getOptionsService',
      'getOptionsFilterPartyME',
      'getAccountingCloses',
      'getAccountingClose',
      'getAccountinCloseInvoiceNotes',
      'isBuyerFilterableState',
      'addChildAccounting',
      'saveAccounting',
      'removeInvoiceSelected',
      'closeAccountinClose',
      'getAllAccountinCloseInvoiceNotes',
      'handleDownloadMultiInvoiceNotesPdf',
      'getInvoiceNoteAttachments',
      'downloadInvoiceNoteAttachment',
      'getInvoiceNoteEvents',
      'deleteAccountingClosesDraft',
      'optionsServicesEnabledState'
    ]),

    formatterStatus (row, column) {
      return this.$t('status_accounting_close.' + row[column.property])
    },
    formatterStatusInvoice (row, column) {
      if (row[column.property]) {
        return this.$t('invoice_status.' + row[column.property])
      }
    },
    // Formatear metodo de envio
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },
    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },
    formatterCategory (row, column) {
      return row[column.property] ? this.$t('auditory_detail.events.code.' + row[column.property]) : ' '
    },
    handleCellMouseEnterAttach (row, column, cell, event) {
      this.currentRowAttachments = row
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    renderHeaderActions: h => {
      return <B2bTableMenuAccountingCloseDraft />
    },
    async sortHasChanged (sort) {
      if (this.loading) {
        return
      }
      if (
        this.tableSort.prop !== sort.prop ||
        this.tableSort.order !== sort.order
      ) {
        this.tableSort = {
          prop: sort.prop,
          order: sort.order
        }
        await this.doSearch(this.$t('msg_generics.order_table'))
      }
    },

    async pageSizeChanged (size) {
      if (this.loading) {
        return
      }
      this.pagination.pageSize = size
      await this.doSearch(this.$t('msg_generics.size_table'))
    },

    async currentPageChanged (page) {
      if (this.loading) {
        return
      }
      this.pagination.currentPage = page
      await this.doSearch(this.$t('msg_generics.pagination_table'))
    },
    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    async getDateTimePickerValueCloseDatePeriod () {
      if (!this.dateTimePickerValueCloseDatePeriod) {
        this.draftDetailForm.startDate = ''
        this.draftDetailForm.endDate = ''
      } else {
        this.draftDetailForm.startDate = this.dateTimePickerValueCloseDatePeriod[0]
        this.draftDetailForm.endDate = this.dateTimePickerValueCloseDatePeriod[1]
      }
    },
    async getProject (data) {
      try {
        // Se recarga compradores
        await this.isBuyerFilterableState(true)
        this.cleanBuyers()

        const dataQueryBuyer = {
          role: 'BUYER',
          page: 0,
          size: 25,
          projectId: [data],
          sponsor: true
        }

        console.log('getProject dentro de componente info')

        const compradores = await this.getOptionsFilterPartyME(dataQueryBuyer)
        if (compradores.length < 21) {
          this.optionsBuyer = compradores
          await this.isBuyerFilterableState(false)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    cleanBuyers () {
      this.optionsBuyer = []
      this.draftDetailForm.buyerName = null
    },
    // Elimina el borrador
    async deleteAccountingClose () {
      try {
        this.$confirm(this.$t('accounting_closes_detail.confirm.title_delete_draft'), {
          confirmButtonText: this.$t('buttons.btnDelete'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          await this.deleteAccountingClosesDraft(this.$route.params.draftId)
          router.push({ name: 'borradorescierres-page' })
          this.$notify({
            title: this.$t('accounting_closes_detail.notify.delete_draft_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }).catch(() => {})
      } catch (error) {
        console.log('handleDeleteUser CATCH:: ' + error)
        this.getNotificationErrorMessage(error)
      }
    },
    /** Guarda los cambios del cierre */
    async cleanChildAccountingClose () {
      console.log('cleanChildAccountingClose: ', this.draftDetailForm)
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.save_changes')
      })
      try {
        const request = {
          childAccountingCloseId: null,
          id: (this.draftId ? this.draftId : null)
        }
        const response = await this.addChildAccounting(request)
        this.draftDetailForm = response
        this.$notify({
          title: this.$t('accounting_closes.notify.update_changes'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        await this.getAccountingCloseOnDatabase()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleRemoveInvoice (row) {
      this.multipleSelectionIds.filter(
        (item, index, self) => {
          return index === self.indexOf(item)
        })
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const params = {
          invoicesId: [row.id],
          draftId: this.draftId
        }
        await this.removeInvoiceSelected(params)
        this.$notify({
          title: this.$t('accounting_closes.notify.update_changes'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        await this.doSearchInvoices()
        this.isShowSeeAttachments = false
        this.isShowSeeEvents = false
      } catch (error) {
        console.log('doSearchInvoices CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleRemoveAllInvoice () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const params = {
          invoicesId: null,
          draftId: this.draftId
        }
        await this.removeInvoiceSelected(params)
        this.$notify({
          title: this.$t('accounting_closes.notify.update_changes'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        await this.doSearchInvoices()
        this.isShowSeeAttachments = false
        this.isShowSeeEvents = false
      } catch (error) {
        console.log('doSearchInvoices CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleCloseAccounting (accountingCloseId) {
      try {
        this.$confirm(this.$t('accounting_closes_detail.confirm.title_close_draft'), {
          confirmButtonText: this.$t('buttons.btnConfirm'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          try {
            if (this.queryParams === null || this.queryParams === undefined) {
              this.queryParams = {}
            }
            this.queryParams.id = this.draftId
            const response = await this.closeAccountinClose(this.queryParams)
            console.log('response close: ', response)
            if (response.statusCode === 'signature.ok') {
              router.push({ name: 'borradorescierres-page' })
              this.$notify({
                title: this.$t('accounting_closes_detail.confirm.close_ok'),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            } else {
              this.$notify({
                title: this.$t('accounting_closes_detail.confirm.close_ko'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            }
          } catch (error) {
            console.error('doSearch CATCH: ', error)
            this.getNotificationErrorMessage(error)
          }
        }).catch(() => {})
      } catch (error) {
        console.error('doSearch CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getAccountingClosesList () {
      sessionStorage.setItem('draftId', this.draftId)
      router.push({
        name: 'cierrescontables-table',
        params: {
          draftId: this.draftId
        }
      })
    },
    // Paginación de facturas
    checkTablePaginationInvoices (size, page, totalElements) {
      this.paginationInvoices = {
        currentPage: totalElements > 0 ? page + 1 : 0,
        totalElements: totalElements,
        pageSize: size
      }
    },
    cleanResultsInvoices () {
      this.invoices = {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'id'
        },
        totalElements: 0,
        totalPages: 0
      }
    },
    checkTableSortInvoices (sort) {
      if (
        sort === null ||
      sort === undefined ||
      sort.field === null ||
      sort.field === undefined
      ) {
        this.tableInvoiceSort = {
          prop: null,
          order: null
        }
      // this.$refs.invoices.clearSort()
      } else {
        const sortAux = {
          prop: sort.field,
          order: sort.direction === 'ASC' ? 'ascending' : 'descending'
        }
        if (
          sortAux.prop !== this.tableInvoiceSort.prop ||
        sortAux.order !== this.tableInvoiceSort.order
        ) {
          this.tableInvoiceSort = sortAux
          // this.$refs.invoices.clearSort()
          this.$refs.invoices.sort(
            this.tableInvoiceSort.prop,
            this.tableInvoiceSort.order
          )
        }
      }
    },
    async currentPageInvoicesChanged (page) {
      if (this.loading) {
        return
      }
      this.paginationInvoices.currentPage = page
      await this.doSearchInvoices(this.$t('msg_generics.pagination_table'))
    },
    async pageInvoicesSizeChanged (size) {
      if (this.loading) {
        return
      }
      this.paginationInvoices.pageSize = size
      await this.doSearchInvoices(this.$t('msg_generics.size_table'))
    },

    backToTableList () {
      router.push({ name: 'borradorescierres-page' })
    },

    // Descarga de pdf
    async handleDownloadInvoicePdf (row, scope) {
      console.log('handleDownloadInvoicePdf: ', row.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })

      try {
        const idList = [row.id]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Ver eventos
    async handleShowSeeEvents (row, scope) {
      console.log('handleShowSeeEvents: ', row.id)
      if (this.invoiceId === row.id) {
        this.isShowSeeEvents = !this.isShowSeeEvents
        if (this.isShowSeeAttachments) {
          this.activateLinesInvoice = ['1']
        }
        if (this.isShowSeeEvents && this.isShowSeeAttachments) {
          this.activateLinesInvoice = ['1', '2']
        } else if (this.isShowSeeEvents) {
          this.activateLinesInvoice = ['2']
        }
      } else {
        this.invoiceId = row.id
        this.isShowSeeEvents = true
        this.activateLinesInvoice = ['2']
        this.isShowSeeAttachments = false
      }
      try {
        if (this.isShowSeeEvents) {
          await this.getInvoiceNoteEventsOnDatabase(this.invoiceId)
        }
      } catch (error) {
        console.log('handleShowSeeEvents CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Ver adjuntos
    async handleShowSeeAttachments (row, scope) {
      console.log('showSeeAttachments: ', row.id)
      if (this.invoiceId === row.id) {
        this.isShowSeeAttachments = !this.isShowSeeAttachments
        if (this.isShowSeeEvents) {
          this.activateLinesInvoice = ['2']
        }
        if (this.isShowSeeAttachments && this.isShowSeeEvents) {
          this.activateLinesInvoice = ['1', '2']
        } else if (this.isShowSeeAttachments) {
          this.activateLinesInvoice = ['1']
        }
      } else {
        this.invoiceId = row.id
        this.isShowSeeAttachments = true
        this.activateLinesInvoice = ['1']
        this.isShowSeeEvents = false
      }
      try {
        if (this.isShowSeeAttachments) {
          await this.getInvoiceNoteAttachmentsOnDatabase()
        }
      } catch (error) {
        console.log('showSeeAttachments CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async downloadAttachment () {
      console.log('downloadAttachment: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.download_attachment')
      })
      try {
        const filename = await this.downloadInvoiceNoteAttachment({
          invoiceNoteId: this.invoiceId,
          attachmentId: this.currentRowAttachments.id,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getInvoiceNoteAttachmentsOnDatabase () {
      // Get Adjuntos
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        this.attachments = await this.getInvoiceNoteAttachments(params)
      } catch (error) {
        console.log('getInvoiceNoteAttachmentsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // EVENTOS
    async getInvoiceNoteEventsOnDatabase (invoiceId) {
      try {
        this.events = await this.getInvoiceNoteEvents({
          invoiceNoteId: invoiceId,
          searchType: this.searchType
        })
      } catch (error) {
        console.log('getInvoiceNoteeventsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getInvoiceList () {
      sessionStorage.setItem('draftId', this.draftId)
      router.push({
        name: 'facturas-recibidas-page',
        params: {
          draftId: this.draftId
        }
      })
    },
    async doSearchInvoices (loadingText) {
      if (this.loading) {
        return false
      }
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: loadingText
      })
      this.cleanResultsInvoices()
      try {
        this.isShowInvoicesList = true
        this.activateLines = ['2']

        if (this.queryParams === null || this.queryParams === undefined) {
          this.queryParams = {}
        }
        this.queryParams.draftId = this.draftId
        this.queryParams.size = this.paginationInvoices.pageSize
        this.queryParams.page =
          this.paginationInvoices.currentPage > 0
            ? this.paginationInvoices.currentPage - 1
            : undefined
        this.queryParams.sort =
          this.tableInvoiceSort.prop != null
            ? this.tableInvoiceSort.prop +
              ',' +
              (this.tableInvoiceSort.order === 'ascending' ? 'ASC' : 'DESC')
            : undefined

        const facturas = await this.getAccountinCloseInvoiceNotes(this.queryParams)
        this.invoices = facturas.content
        this.invoices.size = facturas.size
        this.invoices.number = facturas.number
        this.invoices.totalElements = facturas.totalElements

        this.checkTableSortInvoices(this.invoices.sort)
        this.checkTablePaginationInvoices(
          this.invoices.size,
          this.invoices.number,
          this.invoices.totalElements
        )
        console.log('doSearchInvoices RESULT: ', this.invoices)
      } catch (error) {
        console.error('doSearchInvoices CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.loading = false
      }
    },
    async getBuyerResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const dataQueryBuyer = {
        role: 'BUYER',
        page: 0,
        size: 1000,
        // enabled: true,
        projectId: this.draftDetailForm.projectName,
        sponsor: true,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyME(dataQueryBuyer)
        this.auxListPartiesBuyer = response
        this.optionsBuyer = response
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesBuyer (data) {
    // Solo filtraremos por vendedor si previamente se a seleccionado servicio
      if (this.draftDetailForm.projectName && this.isBuyerFilterable) {
        try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
          if (data.length >= 3) {
            clearTimeout(this.tid)
            this.tid = setTimeout(this.getBuyerResults, 1000, data)
          // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
          } else {
            this.optionsSeller = []
            this.auxListPartiesSeller = []
          }
        } catch (error) {
          console.log('filterPartiesSeller CATCH: ', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },

    /** Guarda los cambios del cierre */
    saveAccountingData (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('saveAccountingData: ', this.draftDetailForm)
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.update_changes')
          })
          try {
            const request = {
              projectName: '' + this.draftDetailForm.projectName,
              buyerName: '' + this.draftDetailForm.buyerName,
              name: this.draftDetailForm.name,
              description: this.draftDetailForm.description,
              startDate: this.draftDetailForm.startDate,
              endDate: this.draftDetailForm.endDate,
              childAccountingCloseId: (this.currentRow && this.currentRow.id ? '' + this.currentRow.id : ''),
              id: (this.draftId ? this.draftId : null)
            }
            const response = await this.saveAccounting(request)
            this.draftId = response.id
            this.draftDetailForm = response
            this.$notify({
              title: this.$t('accounting_closes.notify.update_changes'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.isSavedAccounting = true
            this.isShowSaveButton = false
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('saveAccountingData: ', this.draftDetailForm
          )
        }
      })
    },
    async getAccountingCloseOnDatabase () {
      try {
        const draft = await this.getAccountingClose(this.draftId)
        this.draftDetailForm = draft
        if (this.draftDetailForm.startDate != null) {
          this.dateTimePickerValueCloseDatePeriod.push(this.draftDetailForm.startDate)
        }
        if (this.draftDetailForm.endDate != null) {
          this.dateTimePickerValueCloseDatePeriod.push(this.draftDetailForm.endDate)
        }
      } catch (error) {
        console.log('getAccountingCloseOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          if (error.data.message) {
            errorSms = error.data.message
          } else {
            errorSms = 'global_error'
          }
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Si tiene 1 solo proyecto seteamos el proyecto
      if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
        this.draftDetailForm.projectName = this.activeUser.data.projects[0].id
        await this.getProject(this.draftDetailForm.projectName)
      }

      this.draftId = (this.$route.params && this.$route.params.draftId ? this.$route.params.draftId : null)
      if (this.draftId) {
        await this.getAccountingCloseOnDatabase()
        await this.doSearchInvoices()
      }

      const dataQueryService = {
        page: 0,
        size: 1000,
        enabled: true,
        sort: 'name,ASC'
      }
      this.optionsService = await this.getOptionsService(dataQueryService)
      await this.optionsServicesEnabledState(this.optionsService)
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-add-accountingclose-draft {
  padding: 40px 40px 40px 40px;
  .withIcon.ods-input.ods-input--mini.is-disabled {
    width: 94%;
    margin-top: 7px;
  }
  .icon {
    float: right;
  }
  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }
  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 5px;
  }
  .ods-button.margintop{
      margin-top: 3px;
      margin-left: 15px;
  }
  .ods-button.margintop + .ods-button.margintop {
    margin-right: 0px !important;
    margin-left: 5px !important;
  }

  .collapse {
    margin-top: 25px;
    border-bottom: 0px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }
  ::v-deep .ods-input.is-disabled {
    .ods-input__inner {
      width: 90%;
    }
  }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          border-color: transparent;
          background-color: transparent;
          color: #2E6C99;
          padding: 0px;
          margin-left: 0px !important;
          margin-right: 0px !important;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  .ods-button + .ods-button {
    margin-right: 10px !important;
    margin-left: 0px !important;
  }
}
</style>
